import type { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

export type SnackbarVariant = 'danger' | 'info' | 'success' | 'warning';
export type SnackbarPosition = 'left' | 'right';

export type ShowSnackbarOptions = {
  text: React.ReactNode;
  variant?: SnackbarVariant;
  delay?: number;
  autohide?: boolean;
  position?: SnackbarPosition;
  icon?: FontAwesomeIconProps['icon'];
};

export const SHOW_SNACKBAR_EVENT = 'ui:show-snackbar';

export const showSnackbar = (opts: ShowSnackbarOptions) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SHOW_SNACKBAR_EVENT, { detail: opts }));
};
